import {
  REJECT_REASON_CREATE, REJECT_REASON_SAVE_FAILURE, REJECT_REASON_SAVE_SUCCESS
} from './mutation-types'

export default {
  state: {
    reject_reasons: []
  },
  getters: {
    reject_reasons: state => {
      return state.reject_reasons
    }
  },
  actions: {
    [REJECT_REASON_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/master/reject_reasons', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(REJECT_REASON_SAVE_FAILURE, res.data)
            } else {
              commit(REJECT_REASON_SAVE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [REJECT_REASON_SAVE_FAILURE] (state, data) {
      console.log('REJECT_REASON_SAVE_FAILURE')
    },
    [REJECT_REASON_SAVE_SUCCESS] (state, data) {
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rejectreason-new.js